export const persons = new webix.DataCollection({
	url:"data/persons.json"
});
